import { useFeatureFlagsStore } from './store';

// Must Be Removed Use Store Or Feature Toggle Instead
export const useFeatureFlags = () => {
  const features = useFeatureFlagsStore((store) => store.data);
  const checkFeature = useFeatureFlagsStore((store) => store.checkFeature);
  return { features, checkFeature };
};
